export default __webpack_public_path__ + "static/media/location.6b5457f0.svg";